/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SupplierOfficeDto } from './offices.dto';

@Injectable()
export class SupplierOfficeRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAll(): Observable<SupplierOfficeDto[]> {
    return this.httpGet(`/offices`, identity());
  }
}
